import React, { useEffect, PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";
import useGoogleAnalytics, { trackingId } from "hooks/useGoogleAnalytics";
import { feature_toggle } from "featureToggle";

const GoogleAnalyticsProvider: React.FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const { trackPageView } = useGoogleAnalytics();
  const location = useLocation();

  useEffect(() => {
    if (trackingId && feature_toggle.googleTagManager.isEnable === true) {
      try {
        trackPageView(location.pathname + location.search);
      } catch (error) {
        console.log("Error on trackPageView Google Analytics", {
          Error: error,
        });
      }
    }
  }, [location, trackPageView]);
  return <>{children}</>;
};

export default GoogleAnalyticsProvider;
